import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Set document title and reset accent color
  React.useEffect(() => {
    document.title = 'Administratie';

    // Reset accent color to default blue when on login page
    document.documentElement.style.setProperty('--accent-color', '#3B82F6');
    document.documentElement.style.setProperty('--accent-color-hover', '#2563EB');
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;
    } catch (error: any) {
      setError('Ongeldige inloggegevens');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <p className="text-gray-400 text-sm">Administratie</p>
        </div>
        <div className="bg-gray-800 rounded-xl border border-gray-700 p-8 shadow-xl">
          <form className="space-y-5" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-500/10 text-red-400 p-3 rounded-lg text-sm flex items-center justify-center border border-red-500/20">
                {error}
              </div>
            )}

            <div className="space-y-4">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-300 mb-1.5"
                >
                  E-mailadres
                </label>
                <input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-lg border border-gray-700 px-3.5 py-2.5
                    bg-gray-800 text-white
                    placeholder-gray-500
                    focus:border-accent focus:bg-gray-700 focus:ring-1 focus:ring-accent
                    focus:outline-none
                    transition-all duration-200"
                  placeholder="naam@bedrijf.nl"
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-300 mb-1.5"
                >
                  Wachtwoord
                </label>
                <input
                  id="password"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full rounded-lg border border-gray-700 px-3.5 py-2.5
                    bg-gray-800 text-white
                    placeholder-gray-500
                    focus:border-accent focus:bg-gray-700 focus:ring-1 focus:ring-accent
                    focus:outline-none
                    transition-all duration-200"
                  placeholder="••••••••"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center px-4 py-3
                rounded-lg text-base font-medium text-white bg-accent hover:bg-accent-hover
                focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-gray-900
                disabled:opacity-50 disabled:cursor-not-allowed
                transition-colors duration-200"
            >
              {loading ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Inloggen...
                </div>
              ) : (
                'Inloggen'
              )}
            </button>

            <div className="text-center mt-5">
              <p className="text-sm text-gray-400">
                Nog geen account?{' '}
                <button
                  type="button"
                  onClick={() => navigate('/register')}
                  className="text-accent font-medium hover:text-accent-hover focus:outline-none transition-colors"
                >
                  Registreer hier
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}